import { useFormik } from "formik";
import TextInput from "../../../components/inputs/textInput";
import Button from "../../../components/buttons/button";
import * as yup from "yup";

const AccountSettingsTab = ({ t }) => {
  const accountValidationSchema = yup.object({
    name: yup.string().required(t("required")),
    email: yup.string().email(t("invalidEmail")).required(t("required")),
    phone: yup.string().required(t("required")),
  });

  const passwordValidationSchema = yup.object({
    currentPassword: yup.string().required(t("required")),
    newPassword: yup.string().min(6, t("passwordMin")).required(t("required")),
    reEnterPassword: yup
      .string()
      .oneOf([yup.ref("newPassword"), null], t("passwordsMustMatch"))
      .required(t("required")),
  });
  const accountFormik = useFormik({
    initialValues: { name: "", email: "", phone: "" },
    validationSchema: accountValidationSchema,
    onSubmit: (vals) => {
      console.log(vals);
    },
  });
  const passwordFormik = useFormik({
    initialValues: { currentPassword: "", newPassword: "", reEnterPassword: "" },
    validationSchema: passwordValidationSchema,
    onSubmit: (vals) => {
      console.log(vals);
    },
  });
  return (
    <>
      <div className="mb-4 space-y-5">
        <h2 className="text-lg font-medium text-mainGray">{t("accountSettings")}</h2>
        <form
          onSubmit={accountFormik.handleSubmit}
          className="p-4 space-y-5 rounded-2xl bg-sideBar"
        >
          <div className="inputs">
            <TextInput label={t("fullName")} name={"name"} formik={accountFormik} />
            <TextInput label={t("email")} name={"email"} formik={accountFormik} />
          </div>

          <div className="inputs">
            <TextInput label={t("phone")} name={"phone"} formik={accountFormik} />
          </div>
          <Button className={"bg-primary flex justify-center text-black py-3"}>
            {t("save")}
          </Button>
        </form>
      </div>
      <div className="space-y-5">
        <h2 className="text-lg font-medium text-mainGray">{t("changePassword")}</h2>
        <form
          onSubmit={passwordFormik.handleSubmit}
          className="p-4 space-y-5 rounded-2xl bg-sideBar"
        >
          <div className="inputs">
            <TextInput
              label={t("currentPassword")}
              name={"currentPassword"}
              formik={passwordFormik}
              type="password"
            />
            <TextInput
              label={t("newPassword")}
              name={"newPassword"}
              formik={passwordFormik}
              type="password"
            />
          </div>

          <div className="inputs">
            <TextInput
              label={t("reEnterPassword")}
              name={"reEnterPassword"}
              formik={passwordFormik}
              type="password"
            />
          </div>
          <Button className={"bg-primary my-4 flex justify-center text-black py-3"}>
            {t("save")}
          </Button>
        </form>
      </div>
    </>
  );
};

export default AccountSettingsTab;
